const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" >
    <path d="M30.83 14.83l-2.83-2.83-12 12 12 12 2.83-2.83-9.17-9.17z" stroke="black" stroke-width="1"  style="fill: white"/>
    <path d="M0 0h48v48h-48z" fill="none" />
</svg>`;

export default svg;
